import LocaleSelect from '@component/LocaleSelect'
import { AppBar, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

function Header () {
  return (
    <AppBar
      elevation={1}
      className="flex !flex-row justify-between px-12 py-4 !relative !bg-slate-800"
    >
      <div className="flex items-center">
        <a
          href="https://라임구조설계.kr"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-4"
        >
          <img
            src="/image/header_title.png"
            alt="header_logo"
            style={{
              height: 60,
              width: 'auto',
              maxWidth: 500,
              objectFit: 'contain',
              display: 'block',
              cursor: 'pointer',
            }}
          />
          <img
            src="/image/header_contact.png"
            alt="header_contact"
            style={{
              height: 60,
              width: 'auto',
              maxWidth: 500,
              objectFit: 'contain',
              display: 'block',
              cursor: 'pointer',
            }}
          />
        </a>
      </div>
      <div className="flex items-center">
        <LocaleSelect />
      </div>
    </AppBar>
  )
}

export default Header
